export const CARD = "158ac8a0-b53c-456e-b079-1c3b45aa6bba";
export const SWISH = "58614e8c-5a19-4a93-ba5a-7d7960c44319";
export const GIFTCERTIFICATE = "6e968fb5-ab42-43a0-b154-7af8d8e839b8";
export const INVOICE = "1f3b46cd-eae5-461b-986f-fef8d3f90839";
export const KLARNA = "fab18264-8201-494c-8fd8-d18bd82169f5";
export const NETSEASY = "cf7d0501-1577-4158-b434-6e9d7af7a7da";
export const SWEDBANKPAY = "7a179076-0121-40b6-b932-53693a5da916";

export const getMethodById = (id) => {
  switch (id) {
    case CARD:
      return {
        name: "card",
        identifier: false,
        providesResponsible: true,
        supportsOnePage: false,
      };
    case SWISH:
      return {
        name: "swish",
        identifier: true,
        providesResponsible: true,
        supportsOnePage: true,
      };
    case GIFTCERTIFICATE:
      return {
        name: "giftcertificate",
        identifier: true,
        providesResponsible: true,
        supportsOnePage: false,
      };
    case INVOICE:
      return {
        name: "invoice",
        identifier: true,
        providesResponsible: true,
        supportsOnePage: false,
      };
    case KLARNA:
      return {
        name: "Payment_Add_Klarna",
        identifier: false,
        providesResponsible: false,
        supportsOnePage: true,
      };
    case NETSEASY:
      return {
        name: "Payment_Add_NetsEasy",
        identifier: false,
        providesResponsible: false,
        supportsOnePage: true,
      };
      case SWEDBANKPAY:
      return {
        name: "Payment_Add_SwedbankPay",
        identifier: false,
        providesResponsible: true,
        supportsOnePage: true,
      };
    default:
      return id;
  }
};
